import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';
import CollectorStepSummary from '../../../Dashboard/components/WinLossOpportunityTable/CollectorStepSummary';

class SurveyPlanModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      survey: null,
    };
    this.close = this.close.bind(this);
    this.onExited = this.onExited.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.survey) {
      if (!this.props.survey || this.props.survey.id !== nextProps.survey) {
        this.setState({ open: true, survey: nextProps.survey });
      }
    } else {
      this.setState({ open: false });
    }
  }

  onExited() {
    this.setState({ survey: null }, () => {
      this.props.onClose();
    });
  }

  close() {
    this.setState({ open: false });
  }


  render() {
    const { open, survey } = this.state;
    const { isAccount } = this.props;
    const hasSurvey = survey && survey.id;
    const props = {};
    if (hasSurvey) {
      if (isAccount) {
        props.account_id = survey.object_id;
      } else {
        props.opportunity_id = survey.object_id;
      }
    }
    return (
      <Modal
        show={open}
        onHide={this.close}
        onExited={this.onExited}
        bsSize="lg"
      >
        {hasSurvey &&
          <Modal.Header closeButton>
            <Modal.Title>Email Outreach Plan for {survey.first_name} {survey.last_name}</Modal.Title>
          </Modal.Header>
        }
        {hasSurvey &&
          <Modal.Body>
            <CollectorStepSummary
              isAccount={isAccount}
              survey={survey}
              collector={{
                collector_id: survey.collector_id,
                time_zone: survey.time_zone,
                email_from: survey.email_from,
                program_id: survey.program_id,
                client_id: survey.client_id,
                from_email: survey.collector_email,
                collector_name: survey.collector_name,
              }}
              object={props}
            />
          </Modal.Body>
        }
        <Modal.Footer>
          <Button bsStyle="link" onClick={this.close}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

SurveyPlanModal.propTypes = {
  survey: PropTypes.shape({
    id: PropTypes.string,
    contact_id: PropTypes.string,
    first_name: PropTypes.string,
    last_name: PropTypes.string,
    collector_id: PropTypes.string,
    time_zone: PropTypes.shape({}),
    object_id: PropTypes.string,
  }),
  onClose: PropTypes.func,
  isAccount: PropTypes.bool,
};
SurveyPlanModal.defaultProps = {
  survey: null,
  isAccount: false,
  onClose: () => {},
};
SurveyPlanModal.contextTypes = {
};

export default SurveyPlanModal;
